export enum MeteringPeriods {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year',
    Custom = 'custom'
}
